import validateVar from "./validation/validateVariable";
import {emptyValue} from "./global";

function getConsumptionPointIdentifier(market_identifier, meter_identifier){
    if(validateVar(market_identifier) && market_identifier !== 'Nicht hinterlegt') return market_identifier;
    else if(validateVar(meter_identifier)) return meter_identifier;
    else return emptyValue;
}

export default getConsumptionPointIdentifier;